module.exports = __webpack_public_path__ + "static/media/HU.3aa16a91.png";